import "@loot-os/ui/globals.css";
import "@loot-os/react/styles.css";
import "./termly.css";

import { registerAllOpeners } from "@loot-os/react/openers";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RevealClaimProvider } from "./components/RevealClaimProvider.js";
import { ShopperProvider } from "./components/ShopperProvider.js";
import { TenantConfigProvider } from "./components/TenantConfigProvider.js";
import { initAnalytics } from "./lib/analytics.js";
import { queryClient } from "./lib/queryClient.js";
import { initSentry } from "./lib/sentry.js";
import { router } from "./router.js";

// Every box opens with its opener style's kind; each three.js scene and its stylesheet load on
// first use.
registerAllOpeners();

initSentry(router);
initAnalytics(router);

const container = document.getElementById("root");
if (!container) throw new Error("missing #root");
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TenantConfigProvider>
        <ShopperProvider>
          <RevealClaimProvider>
            <RouterProvider router={router} />
          </RevealClaimProvider>
        </ShopperProvider>
      </TenantConfigProvider>
    </QueryClientProvider>
  </StrictMode>,
);
